module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"tarifCategoryTitle":"BFE-Verbraucherprofil","gridTarifTitle":"Netznutzung","energyTarifTitle":"Energie","taxesTarifTitle":"Steuern","kevTarifTitle":"KEV","totalTitle":"Total","userDefined":"Benutzer definiert","cancelEdit":"Abbrechen"}}')
  delete Component.options._Ctor
}
